import _createClass from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/srv/nobackup/gitlabrunner/builds/t1_tyu7Co/0/entente-lot/lvdlr-2020-front/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import DygraphBase from '@qogni/dygraphs';
import { propTypes as dygraphPropTypes, spreadProps as spreadKnownProps } from './Dygraph/options';
import DayMarker from '../plugins/DayMarker';
import ChartBackground from '../plugins/ChartBackground';
import ChartBorder from '../plugins/ChartBorder';
import FixedYAxis from '../plugins/FixedYAxis';
import Normalize from '../plugins/Normalize';
import Downsample from '../plugins/Downsample';
import StickyEdges from '../plugins/StickyEdges';
import DateTickerWorkaround from '../plugins/DateTickerWorkaround';
import SupressEmptyDataError from '../plugins/SupressEmptyDataError';
import NoWarningRangeSelector from '../plugins/NoWarningRangeSelector';
import VisibilityRedraw from '../plugins/VisibilityRedraw';
import ConstrainDateWindow from '../plugins/ConstrainDateWindow';
import OptimizedDataHandler from '../datahandler/Optimized';
DygraphBase.PLUGINS[DygraphBase.PLUGINS.indexOf(DygraphBase.Plugins.RangeSelector)] = NoWarningRangeSelector;

var InteractionModelProxy = function InteractionModelProxy() {
  var _this = this;

  _classCallCheck(this, InteractionModelProxy);

  this._target = DygraphBase.defaultInteractionModel;

  var _loop = function _loop() {
    var method = _arr[_i];
    var thisProxy = _this;

    _this[method] = function () {
      var _thisProxy$_target$me;

      var calledContext = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_thisProxy$_target$me = thisProxy._target[method]).call.apply(_thisProxy$_target$me, [calledContext].concat(args));
    };
  };

  for (var _i = 0, _arr = ['mousedown', 'touchstart', 'touchmove', 'touchend', 'dblclick']; _i < _arr.length; _i++) {
    _loop();
  }

  ['willDestroyContextMyself'].forEach(function (prop) {
    Object.defineProperty(_this, prop, {
      configurable: false,
      enumerable: true,
      get: function get() {
        return _this._target[prop];
      },
      set: function set(value) {
        return _this._target[prop] = value;
      }
    });
  });
};

var Dygraph = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Dygraph, _React$PureComponent);

  var _super = _createSuper(Dygraph);

  function Dygraph() {
    var _this2;

    _classCallCheck(this, Dygraph);

    var _temp;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _possibleConstructorReturn(_this2, (_temp = _this2 = _super.call.apply(_super, [this].concat(args)), _this2.displayName = 'Dygraph', _this2._interactionProxy = new InteractionModelProxy(), _temp));
  }

  _createClass(Dygraph, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _spreadKnownProps = spreadKnownProps(this.props, true);

      var initAttrs = _spreadKnownProps.known;
      this._interactionProxy._target = initAttrs.interactionModel || DygraphBase.defaultInteractionModel;
      initAttrs.interactionModel = this._interactionProxy;

      if (!initAttrs.dataHandler) {
        initAttrs.dataHandler = OptimizedDataHandler;
      }

      if (!initAttrs.plugins) {
        initAttrs.plugins = [];
      }

      initAttrs.plugins.push(new SupressEmptyDataError());
      initAttrs.plugins.push(new DateTickerWorkaround());
      initAttrs.plugins.push(new VisibilityRedraw());

      if (this.props.dayMarker) {
        initAttrs.plugins.push(new DayMarker());
      }

      if (this.props.chartBorder) {
        initAttrs.plugins.push(new ChartBorder());
      }

      if (this.props.chartBackground) {
        if (typeof this.props.chartBackground === 'boolean') {
          initAttrs.plugins.push(new ChartBackground());
        } else {
          initAttrs.plugins.push(new ChartBackground(this.props.chartBackground));
        }
      }

      if (this.props.normalize) {
        initAttrs.plugins.push(new Normalize(this.props.normalize));
      }

      if (this.props.downsample) {
        var normalizeOPtions = this.props.downsample;

        if (typeof this.props.downsample === 'boolean') {
          normalizeOPtions = null;
        }

        initAttrs.plugins.push(new Downsample(normalizeOPtions));
      }

      if (this.props.fixedYAxis) {
        initAttrs.plugins.push(new FixedYAxis());
      }

      if (this.props.stickyEdges) {
        initAttrs.plugins.push(new StickyEdges(this.props.stickyEdges));
      }

      if (this.props.constrainDateWindow) {
        initAttrs.plugins.push(new ConstrainDateWindow());
      }

      this._dygraph = new DygraphBase(this.root, this.props.data, initAttrs);
      var dateWindow;
      var self = this;
      Object.defineProperty(this._dygraph, 'dateWindow_', {
        enumerable: true,
        get: function get() {
          return dateWindow;
        },
        set: function set(value) {
          if (dateWindow === undefined || dateWindow === null || value === undefined || value === null || value[0] !== dateWindow[0] || value[1] !== dateWindow[1]) {
            dateWindow = value;

            if (self.props.onDateWindowChanged) {
              self.props.onDateWindowChanged(value);
            }
          }
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this._dygraph) {
        var _spreadKnownProps2 = spreadKnownProps(this.props, false);

        var updateAttrs = _spreadKnownProps2.known;
        this._interactionProxy._target = updateAttrs.interactionModel || DygraphBase.defaultInteractionModel;
        updateAttrs.interactionModel = this._interactionProxy;

        if (this.props.normalize && this.props.normalize !== prevProps.normalize) {
          this._dygraph.plugins_.find(function (p) {
            return p.plugin instanceof Normalize;
          }).plugin.updateOptions(this.props.normalize);
        }

        if (this.props.stickyEdges && this.props.stickyEdges !== prevProps.stickyEdges) {
          this._dygraph.plugins_.find(function (p) {
            return p.plugin instanceof StickyEdges;
          }).plugin.updateOptions(this.props.stickyEdges);
        }

        this._dygraph.updateOptions(updateAttrs);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._dygraph) {
        this._dygraph.destroy();

        this._dygraph = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return React.createElement('div', {
        ref: function ref(root) {
          return _this3.root = root;
        },
        style: this.props.style
      });
    }
  }]);

  return Dygraph;
}(React.PureComponent);

export { Dygraph as default };